export default "/dist/files/icon-megaphone-noir.70806c25ccd3b0af2d84804c4c59a5e0.svg";